"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ExternalSearchResults = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _searchResult = require("./search-result");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AccumulatedExternalSearchResults = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(AccumulatedExternalSearchResults, _PureComponent);

  var _super = _createSuper(AccumulatedExternalSearchResults);

  function AccumulatedExternalSearchResults() {
    var _this;

    (0, _classCallCheck2.default)(this, AccumulatedExternalSearchResults);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      hits: []
    });
    return _this;
  }

  (0, _createClass2.default)(AccumulatedExternalSearchResults, [{
    key: "updateList",
    value: function updateList() {
      var joinWith = [];

      if (this.props.pageCount > 0) {
        joinWith = this.state.hits;
      }

      this.setState({
        hits: joinWith.concat(this.props.hits)
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateList();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (JSON.stringify(this.props.hits) === JSON.stringify(prevProps.hits)) return;
      this.updateList();
    }
  }, {
    key: "render",
    value: function render() {
      return (0, _preact.h)(ExternalSearchResults, (0, _extends2.default)({}, this.props, {
        hits: this.state.hits
      }));
    }
  }]);
  return AccumulatedExternalSearchResults;
}(_preactCompat.PureComponent);

exports.default = AccumulatedExternalSearchResults;

var ExternalSearchResults = function ExternalSearchResults(props) {
  var _clickCallback = props.clickCallback,
      customClass = props.customClass,
      hits = props.hits,
      anchorRel = props.anchorRel;
  return (0, _preact.h)("div", {
    className: customClass
  }, hits.map(function (hit, idx) {
    return (0, _preact.h)(_searchResult.ExternalSearchResult, {
      key: hit.objectID,
      hit: hit,
      clickCallback: function clickCallback() {
        return _clickCallback(hit, idx);
      },
      anchorRel: anchorRel
    });
  }));
};

exports.ExternalSearchResults = ExternalSearchResults;